$(document).ready(function() {

    // wenn das Cookie Consent Opt-In aktiv ist, soll der normale Cookie Hinweis nicht mehr angezeigt wird
    if (showCookieConsentWindow === true) {
        return;
    } else {
        if (datenSchutzSeite === true) {
            return;
        }
    }

    // Cookie-Hinweis
    var showCookieHinweis = Cookies.get('showCookieHinweis');

    if (showCookieHinweis == null) {
        showCookieHinweis = "";
    } // if

    if (showCookieHinweis != "false") {
        $(".ttgCookieHinweis").show("slow");
    } // if

    $(".ttgCookieHinweisClose").click(function() {
        Cookies.set('showCookieHinweis', 'false', {
            expires: 30,
            path: '/'
        });
        $(".ttgCookieHinweis").hide("slow");
    });

});